import { Component, Input, OnInit } from "@angular/core";
import { IConfigurationCardOrTable } from "src/app/domain/interfaces/configuration-data.interface";

@Component({
	selector: "app-card-create",
	templateUrl: "./card-create.component.html"
})
export class CardCreateComponent {
	@Input() response: IConfigurationCardOrTable;
}
